import React from 'react';
import AdvancedStatistics from './AdvancedStatistics';

export default function Statistics() {
  return <AdvancedStatistics />;
}
